<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import i18n from '@/i18n';
import { 
	getQueryString, 
	setStorage, 
	removeStorage, 
	invokeApp 
} from "@/util";
export default {
    data() {
        return {};
    },
    mounted() {},
    created() {
        this.loadAccessToken();
        this.loadLang();
        this.loadAppVersion();
        this.inWechat();
        this.whichOs();
		this.loadProxyCode();
    },
    methods: {
		loadProxyCode(){
			if (getQueryString("proxy_code")) {
			    setStorage("proxy_code", getQueryString("proxy_code"));
			    this.$common.proxyCode = getQueryString("proxy_code");
			}
		},
        loadAccessToken() {
            if (getQueryString("access_token")) {
                setStorage("access_token", getQueryString("access_token"));
                this.$common.accessToken = getQueryString("access_token");
            }
        },
        loadLang() {
            if (getQueryString("lang")) {
                setStorage("lang", getQueryString("lang"));
                this.$common.lang = getQueryString("lang");
                i18n.locale = getQueryString("lang");
            }
        },
        loadAppVersion() {
            if (getQueryString("appversion")) {
                setStorage("appversion", getQueryString("appversion"));
                this.$common.appversion = getQueryString("appversion");
            }
        },
        inWechat() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                setStorage("inWechat", true);
                this.$common.inWechat = true;
            } else {
                removeStorage("inWechat");
                this.$common.inWechat = false;
            }
        },
        whichOs() {
            var agent = navigator.userAgent;
            if (agent.indexOf("Android") > -1 || agent.indexOf("Linux") > -1) {
                setStorage("os", "Android");
                this.$common.os = "Android";
                return;
            }
            if (agent.indexOf("iPhone") > -1) {
                setStorage("os", "IOS");
                this.$common.os = "IOS";
                return;
            }
            setStorage("os", "H5");
            this.$common.os = "H5";
        },
    },
};
</script>
<style>
body {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
}

body::-webkit-scrollbar {
    display: none;
}
</style>